import { render, staticRenderFns } from "./mother_current_info.vue?vue&type=template&id=33a5ebf0&scoped=true&"
import script from "./mother_current_info.vue?vue&type=script&lang=js&"
export * from "./mother_current_info.vue?vue&type=script&lang=js&"
import style0 from "./mother_current_info.vue?vue&type=style&index=0&id=33a5ebf0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a5ebf0",
  null
  
)

export default component.exports